import { jsx as e, jsxs as r } from "react/jsx-runtime";
import m from "dayjs";
import "react";
import { useTranslation as d } from "react-i18next";
import "../../../../../contexts/global-context.js";
import "motion/react";
import { OutlineIconButton as t, PrimaryButton as n } from "../../../../../components/elements/button/button.js";
import "@radix-ui/react-dialog";
import "@radix-ui/react-accordion";
import { LinkButton as o } from "../../../../../components/elements/link/link.js";
import "@vis.gl/react-google-maps";
import "haversine-distance";
import i from "./confirm-cancellation.module.less.js";
const f = ({
  booking: l,
  onCloseDrawer: N,
  onConfirm: c,
  isLoadingCancellation: s
}) => {
  const { t: a } = d();
  return /* @__PURE__ */ e("div", { className: i.wrapper, children: /* @__PURE__ */ r("div", { className: [i.innerWrapper, "max-width padded-sides centered"].join(" "), children: [
    /* @__PURE__ */ r("div", { className: i.headingWrapper, children: [
      /* @__PURE__ */ e("h3", { className: "heading-max-width", children: a("TRAILER_RENTAL_CANCELLATION_CONFIRM_CANCELLATION_HEADING", { bookingId: l.bookingId }) }),
      /* @__PURE__ */ e(t, { icon: "ui-icon-close", onClick: N })
    ] }),
    /* @__PURE__ */ r("div", { className: i.bookingDetails, children: [
      /* @__PURE__ */ e("div", { className: i.label, children: a("TRAILER_RENTAL_CANCELLATION_CONFIRM_CANCELLATION_STATION_NAME") }),
      /* @__PURE__ */ e("div", { className: i.details, children: l.locationName }),
      /* @__PURE__ */ e("div", { className: i.label, children: a("TRAILER_RENTAL_CANCELLATION_CONFIRM_CANCELLATION_PICKUP_TIME") }),
      /* @__PURE__ */ e("div", { className: i.details, children: m(l.pickupTime).format("D MMMM, YYYY [kl] HH:mm") }),
      /* @__PURE__ */ e("div", { className: i.label, children: a("TRAILER_RENTAL_CANCELLATION_CONFIRM_CANCELLATION_RETURN_TIME") }),
      /* @__PURE__ */ e("div", { className: i.details, children: m(l.returnTime).format("D MMMM, YYYY [kl] HH:mm") }),
      /* @__PURE__ */ e("div", { className: i.label, children: a("NAME") }),
      /* @__PURE__ */ r("div", { className: i.details, children: [
        l.firstName,
        " ",
        l.lastName
      ] }),
      /* @__PURE__ */ r("div", { className: i.label, children: [
        a("EMAIL"),
        ":"
      ] }),
      /* @__PURE__ */ e("div", { className: i.details, children: l.email })
    ] }),
    /* @__PURE__ */ r("div", { className: i.buttonWrapper, children: [
      /* @__PURE__ */ e(
        n,
        {
          label: a(s ? "CANCELLING_RESERVATION" : "CANCEL_RESERVATION"),
          onClick: c,
          isLoading: s
        }
      ),
      /* @__PURE__ */ e(
        o.Secondary,
        {
          iconLeft: "ui-icon-arrow-left",
          className: i.cancelButton,
          label: a("CANCEL"),
          onClick: N
        }
      )
    ] })
  ] }) });
};
export {
  f as ConfirmCancellation
};
